module.exports = mail => {
   return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(mail)
}



// WEBPACK FOOTER //
// ./src/Helpers/ValidateEmail-new.js